import React, { useEffect } from "react";
import "./Live.css";
import { SlotFilters } from "../../components/Slots/SlotFilters/SlotFilters";
import { Box, Container } from "@mui/material";
import { scrollTop } from "../../utils/scrollTop";
import { useLocation, useNavigate } from "react-router-dom";
import { queryToObject } from "../../utils/queryToObject";
import { useAppSelector } from "../../store/hooks/store.hooks";
import {
  LobbySlotsSection,
  LobbySlotsSectionFilteredByProvider,
} from "../../components/Slots/LobbySlotsSection/LobbySlotsSection";
import { SlotsSection } from "../../components/Slots/SlotsSection/slotsSection";

import all from "../../assets/icons/menu/all.svg";
import popular from "../../assets/icons/menu/popular.svg";
import live from "../../assets/icons/menu/live_casino.svg";
import search_icon from "../../assets/icons/menu/search.svg";
import roulette from "../../assets/icons/menu/roulette.svg";
import card_games from "../../assets/icons/menu/card_games.svg";
import { slotsQueryObjectHelper } from "../../utils/slotsQueryObjectHelper";
import { slotsAttributeHelper } from "../../utils/slotsAttributeHelper";

const filters = [
  {
    name: "all",
    image: all,
    path: "/lobby/live?all=true",
  },
  {
    name: "popular",
    image: popular,
    path: "/lobby/live?popular=true",
  },
  {
    name: "roulette",
    image: roulette,
    path: "/lobby/live?category=roulette",
  },
  {
    name: "card_games",
    image: card_games,
    path: "/lobby/live?category=card_games",
  },
  {
    name: "live",
    image: live,
    path: "/lobby/live",
  },
];

export const Live = () => {
  const { search } = useLocation();
  const query = queryToObject(search);
  const { searchGame } = useAppSelector((state) => {
    return state.slots;
  });
  const navigator = useNavigate();
  const providerChangeHandler = (providerId: number) => {
    navigator(`/lobby/live?provider=${providerId}`);
  };
  useEffect(() => {
    scrollTop();
  }, []);
  return (
    <Box className="lobby-live">
      <Container className="container" maxWidth={false} disableGutters>
        <SlotFilters
          isMain={false}
          section="live"
          filters={filters}
          providerChangeHandler={providerChangeHandler}
        />
        {searchGame ? (
          <LobbySlotsSection
            action="live"
            src={search_icon}
            name={searchGame}
          />
        ) : query.provider ? (
          <LobbySlotsSectionFilteredByProvider
            action="live"
            provider={!isNaN(+query.provider) ? +query.provider : undefined}
          />
        ) : query.all ||
          query.popular ||
          query.recommended ||
          query.new ||
          query.category ? (
          <>
            {query.all && <LobbySlotsSection action="live" src={all} />}
            {query.popular && (
              <LobbySlotsSection action="popular_live" src={popular} />
            )}
            {query.category === "roulette" && (
              <LobbySlotsSection action="roulette" src={roulette} />
            )}
            {query.category === "card_games" && (
              <LobbySlotsSection action="card_games" src={card_games} />
            )}
          </>
        ) : (
          <LobbySlotsSection action="live" src={all} />
        )}
      </Container>
    </Box>
  );
};
